import React from 'react';
import termsAndConditionsBlocksEn from '../content/termsAndConditionsBlocks';
import termsAndConditionsBlocksId from '../content/termsAndConditionsBlocks.id';
import LegalTextPage from './LegalTextPage';

const TermsAndConditions = () => {
    return (
        <LegalTextPage
            blocksByLocale={{
                id: termsAndConditionsBlocksId,
                en: termsAndConditionsBlocksEn
            }}
            noticeByLocale={{
                id: 'Versi Indonesia adalah terjemahan 1:1 dari versi English.',
                en: 'The Indonesian version is a 1:1 translation of the English version.'
            }}
        />
    );
};

export default TermsAndConditions;
